import styles from './Footer.module.css';
import logo from '../../assets/images/traily-logo-1.svg';
import linkedin from '../../assets/images/linkedin.svg';
import instagram from '../../assets/images/Vector.svg';
import twitter from '../../assets/images/Vector (1).svg';
import facebook from '../../assets/images/Vector (2).svg';
import whatsapp from '../../assets/images/Vector (3).svg';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerMain}>
        {/* Coluna 1: Logo + descrição + ícones */}
        <div className={styles.left}>
          <img src={logo} alt="Traily" className={styles.logo} />
          <p className={styles.description}>
            Somos uma plataforma B2B dedicada à gestão e distribuição de conteúdos como ingressos de cinema e games, unindo simplicidade, transparência e curadoria de experiências que fazem a diferença para as pessoas.
          </p>
          <div className={styles.socialIcons}>
            <a href="https://www.linkedin.com/company/use-traily/posts/?feedView=all" aria-label="LinkedIn"><img src={linkedin} alt="LinkedIn" /></a>
            {/*<a href="#" aria-label="Instagram"><img src={instagram} alt="Instagram" /></a>*/}
            {/*<a href="#" aria-label="Twitter"><img src={twitter} alt="Twitter" /></a>
            <a href="#" aria-label="Facebook"><img src={facebook} alt="Facebook" /></a>*/}
            {/*<a href="#" aria-label="WhatsApp"><img src={whatsapp} alt="WhatsApp" /></a>*/}
          </div>
        </div>

        <div className={styles.center}>
          <nav className={styles.nav}>
            <a href="#inicio">Início</a>
            <a href="#funciona">Como funciona</a>
            <a href="#conteudos">Conteúdos</a>
            <a href="#diferenciais">Diferenciais</a>
          </nav>
          <div className={styles.centerDesc}>
            Soluções completas, prontas pra rodar. Tudo que sua marca precisa para entregar valor de verdade. Aqui, experiência e eficiência andam juntas.
          </div>
          <a href="https://tally.so/r/3qXVr9" className={styles.contactBtn} target="_blank" rel="noopener noreferrer">Entrar em contato</a>
        </div>
      </div>

      {/* Linha separadora */}
      <div className={styles.separator}></div>

      {/* Linha inferior */}
      <div className={styles.bottomBar}>
        <div>
          ©2025 Traily. Todos os direitos reservados.
        </div>
        <div className={styles.bottomLinks}>
          <Link to="/privacidade">Políticas de Privacidade</Link>
          <Link to="/termos">Termos de serviços</Link>
          <a href="#cookies">Configurações de Cookies</a>
        </div>
      </div>
    </footer>
  );
}
